import { makeStyles } from '@material-ui/core/styles'
import PageMetaData from '@v4/utils/data/PageMetaData'
import { TEXT_POSITION } from '../../CallToAction.const'

const useStyles = makeStyles(
	theme => ({
		root: {
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			maxWidth: theme.spacing(92),
			width: '100%',
		},
		[TEXT_POSITION.TOP]: {
			'& $additionalText': {
				marginBottom: theme.spacing(2),
			},
		},
		[TEXT_POSITION.BOTTOM]: {
			'& $additionalText': {
				marginTop: theme.spacing(3.2),
			},
		},
		additionalText: {
			textAlign: 'center',

			[theme.breakpoints.down('xs')]: {
				'& *': {
					textAlign: ({ mobileAlignment = null }) => {
						return mobileAlignment && `${mobileAlignment} !important`
					},
				},
			},
		},
		image: {
			display: 'flex',
			justifyContent: 'center',
			height: theme.spacing(16),
			width: theme.spacing(16),
			marginBottom: theme.spacing(2),
			'& img': {
				height: '100%',
				objectPosition: 'center bottom',
				objectFit: 'contain',
			},
		},
		content: {
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			width: '100%',

			[theme.breakpoints.down('xs')]: {
				alignItems: ({ mobileAlignment }) => `${PageMetaData.CONTENT_ALIGNMENT[mobileAlignment]} !important`,
			},
		},
		text: {
			[theme.breakpoints.down('xs')]: {
				'& *': {
					textAlign: ({ mobileAlignment = null }) => {
						return mobileAlignment && `${mobileAlignment} !important`
					},
				},
			},
		},

		buttonWrap: {
			width: '100%',
			display: 'flex',
			justifyContent: 'center',

			[theme.breakpoints.down('xs')]: {
				justifyContent: ({ mobileAlignment }) =>
					`${PageMetaData.CONTENT_ALIGNMENT[mobileAlignment]} !important`,
			},
		},

		button: {
			width: 'auto',
			marginBottom: theme.spacing(1.5),

			[theme.breakpoints.down('xs')]: {
				width: ({ mobileButtonWidth }) => mobileButtonWidth,
			},
		},
	}),
	{ name: 'CallToAction-Content' },
)

export default useStyles
